export const filterAndRenameCioFacets = (cioFacets, facetMapping) => {
    if (Object.keys(facetMapping).length === 0) {
        return cioFacets
    }

    return cioFacets
        .filter((facet) => Object.values(facetMapping).includes(facet.name))
        .map((facet) => {
            const newDisplayName = facetMapping[facet.name] || facet.display_name
            return {
                ...facet,
                display_name: newDisplayName
            }
        })
}

export const extractValueFromSelectedFacets = (selectedFacetFilters) => {
    const result = {}
    Object.entries(selectedFacetFilters).forEach(([category, values]) => {
        result[category] = values.map(({value}) => value)
    })
    return result
}
